<div class="list-container">
    <dynamic-table [props]="props">
        <table class="table">
            <thead>
                <tr class="table-header">
                    <th id="Timestamp" class="table-header-title">{{'log.timestamp' | translate}}</th>

                    <th id="Message" class="table-header-title">{{'log.message' | translate}}</th>

                    <th id="Exception" class="table-header-title">{{'log.exception' | translate}}</th>
                </tr>
            </thead>
            <tbody>
                <ng-container *ngFor="let log of logs">
                    <tr class="row-container ccc ccc-table-row">
                        <td id="Timestamp" class="column-content fw-bold">
                            {{log.timestamp | date:'medium':'+0000'| replaceIfNull}}
                        </td>

                        <td id="Message" class="column-content">
                            <div class="short_txt">
                            {{log.message | replaceIfNull}}
                            </div>
                        </td>

                        <td id="Exception">
                            <div class="column-content short_txt">{{log.exception | replaceIfNull}}</div>
                        </td>

                        <td>
                            <button class="btn copy-clipboard-btn" (click)="onSelectHandler(log)">
                                <i class="app-icon icon icon-copy icon-xl"></i>
                            </button>
                        </td>
                    </tr>
                </ng-container>
            </tbody>
        </table>
    </dynamic-table>
</div>